export type MerchantPricing = {
  /** e.g. "£8" or "€8" — SIM + TMS monthly per device */
  sim_tms_monthly?: string;
  /** e.g. "£3" */
  telemetry_monthly?: string;
  /** e.g. "£2" */
  flair_cards_monthly?: string;
  /** e.g. "£2" */
  corelink_16_monthly?: string;
};

export type MerchantTermSection = {
  title: string;
  /** When true, title is a top-level document part (Merchant Condition). */
  major?: boolean;
  /** Center the title (used for Merchant Condition). */
  center?: boolean;
  paragraphs?: string[];
  items?: { label: string; text: string }[];
};

export const MERCHANT_TERMS_TITLE = 'Merchant Conditions';

export const MERCHANT_TERMS_INTRO =
  'Review the merchant conditions below, then accept to continue.';

export const DEFAULT_MERCHANT_PRICING: Required<MerchantPricing> = {
  sim_tms_monthly: '£8',
  telemetry_monthly: '£3',
  flair_cards_monthly: '£2',
  corelink_16_monthly: '£2',
};

export function resolveMerchantPricing(pricing?: MerchantPricing | null): Required<MerchantPricing> {
  return {
    sim_tms_monthly: pricing?.sim_tms_monthly || DEFAULT_MERCHANT_PRICING.sim_tms_monthly,
    telemetry_monthly: pricing?.telemetry_monthly || DEFAULT_MERCHANT_PRICING.telemetry_monthly,
    flair_cards_monthly: pricing?.flair_cards_monthly || DEFAULT_MERCHANT_PRICING.flair_cards_monthly,
    corelink_16_monthly: pricing?.corelink_16_monthly || DEFAULT_MERCHANT_PRICING.corelink_16_monthly,
  };
}

/**
 * Merchant Conditions only (no Partner Terms).
 * Fee amounts are injected from brand merchant_pricing.
 */
export function buildMerchantTermSections(pricing?: MerchantPricing | null): MerchantTermSection[] {
  const p = resolveMerchantPricing(pricing);
  return [
    {
      title: 'Merchant Condition',
      major: true,
      center: true,
    },
    {
      title: 'Hardware:',
      items: [
        {
          label: 'Price',
          text: 'According to SynthiaX price list or price provided by our partner.',
        },
        {
          label: 'Warranty',
          text: "The Seller warrants that all hardware Goods will be free from defects in materials and workmanship for a period of 12 months from the date of delivery. This warranty does not cover damage caused by misuse, neglect, accident, or unauthorised modification. The Seller's sole liability under this warranty is limited to repairing or replacing defective Goods.",
        },
      ],
    },
    {
      title: 'Payments:',
      items: [
        {
          label: 'Price',
          text: 'According to pricing provided by SynthiaX sales representative or price provided by our partners company. The price is also mentioned in the acquiring contract with Raypd.',
        },
        {
          label: 'Settlement',
          text: 'Merchant is settled Daily, weekly or monthly, please choose it in the payments contract. Settlement',
        },
      ],
    },
    {
      title: 'Monthly Support & Licensing Fee:',
      paragraphs: [
        `You will be charged, ${p.sim_tms_monthly} ( or equivalent amount in your local currency) pr. device pr. month for SIM + TMS, charged monthly with direct debit, unless you have agreed a different amount with our distributor.`,
      ],
    },
    {
      title: 'Add-on Software Fee:',
      items: [
        { label: 'Telemetry', text: `${p.telemetry_monthly} pr. month pr. terminal ( add - on)` },
        { label: 'Flair Cards', text: `${p.flair_cards_monthly} pr. month pr. terminal ( add - on)` },
        { label: 'CoreLink 16', text: `${p.corelink_16_monthly} pr. month pr. terminal ( add - on)` },
      ],
    },
  ];
}

/** @deprecated Prefer buildMerchantTermSections(brandPricing) */
export const MERCHANT_TERM_SECTIONS = buildMerchantTermSections();
